export enum PaymentOperationType {
    Manual = 1,
    Automatic = 2,
    Gateway = 3
}